import 'toastr/toastr.scss'
import 'jquery-mask-plugin/dist/jquery.mask.min.js'
import toastr from 'toastr'
import 'jquery-validation/dist/jquery.validate.js'
import '../libs/recaptcha'
import '../../scss/components/toast'
import '../../scss/components/contactForm'

const settings = require('../../common.json')
const nJsonData = require('../../contact.json')
settings.messages = $.extend({}, settings.messages, nJsonData.messages)

const contactForm = {
  $f: $('form[name="cForm"]'),

  send ($f) {
    toastr.remove()
    toastr.info(settings.messages.contact.sending, '', { closeButton: false, timeOut: 999999 })
    const datas = {
      name: $f.find('input[name="name"]').val(),
      phone: $f.find('input[name="phone"]').val(),
      email: $f.find('input[name="email"]').val() || '',
      demand: $f.find('textarea[name="demand"]').val() || ''
    }

    $f.load()
    $.ajax({
      type: 'POST',
      url: document.location.origin + '/contact/send',
      data: datas,
      success () {
        toastr.remove()
        toastr.success(settings.messages.contact.successSend, '', { closeButton: true, timeOut: 50000, newestOnTop: true })
        $f[0].reset() // reset le formulaire
        /* global ga */
        if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Formulaire contact', 'Soumettre', 'Nouveau contact') }
        /* global gtag */
        if (typeof (googletag) !== 'undefined') { gtag('event', 'new_contact') }
      },
      error () {
        toastr.remove()
        toastr.error(settings.messages.errors.retry)
      },
      complete () {
        $f.load(false)
      }
    })
  },

  initForm () {
    const _this = this
    this.$f.find('.phone').mask('00-00-00-00-00')
    this.$f.find('.email').mask('A', {
      translation: {
        A: { pattern: /[\w@\-.+]/, recursive: true }
      }
    })
    $.each(_this.$f, function (i, elem) {
      $(elem).validate({
        ignore: [], // force à contrôler le select caché par nice-select
        invalidHandler: function (event, validator) {
          toastr.error((validator.numberOfInvalids() === 1) ? settings.messages.forms.validator.missingField : settings.messages.forms.validator.missingFields)
        },
        submitHandler: function (form, e) {
          e.preventDefault()
          $(elem).load()
          $(elem).captcha('verify', {
            success: function () {
              _this.send($(form))
            },
            error: function () {
              toastr.error(settings.messages.errors.retry)
              $(elem).load(false)
            },
            cancel: function () {
              $(elem).load(false)
            },
            action: 'contact'
          })
        },
        rules: {
          name: { required: true, minlength: 3 },
          phone: { required: true, minlength: 14, maxlength: 14 },
          rgpd: { required: true },
          demand: { required: true }
        },
        errorPlacement: function (error, element) {
          error.insertAfter(element.parent())
        }
      })
      const emailField = $(elem).find('input[name="email"]')
      if (emailField.length) { emailField.rules('add', { required: true, email: true }) }
    })
  },

  init () {
    this.$f.captcha()
    this.initForm()
  }

}

contactForm.init()
